import { configureStore } from "@reduxjs/toolkit"
import { sentryMiddleware } from "./sentryMiddleware"

import { apiSlice } from "./apiSlice"
import authReducer from "./authSlice"

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware, sentryMiddleware),

  devTools: true
})

// Export types for use throughout the app
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch